import React from 'react';

const HeaderInfoBar = () => {
  return (
    <div
      className={
        'w-full  bg-grayTertiary text-midGray font-dm-sans z-50 !px-4 md:!px-10 hidden md:block py-2 lg:py-1.5 shadow-md lg:!px-10'
      }
    >
      <div className="max-w-custom mx-auto 2xl:justify-start 2xl:items-center md:flex md:flex-col xl:flex-row  xl:items-center gap-y-1 xl:gapy-y-0 xl:space-x-10">
        <div className="flex space-x-2 items-center">
          <div>
            <img
              src="/health/images/call.svg"
              className="md:h-3 md:w-3"
              alt="call icon"
            />
          </div>
          <div className="text-[13px] font-normal leading-4.5 tracking-normal ">
            ZIM +263 71 080 7966 - USA: (312) 932 8370 - UK: +44 (20) 3744 2394
            - Aus: +61 (8) 6104 3366 - Canada: (902) 332 1282
          </div>
        </div>
        <div className="flex space-x-2 items-center">
          <div>
            <img
              src="/health/images/inbox-mail.svg"
              className="md:h-3 md:w-3"
              alt="mail icon"
            />
          </div>
          <div className="text-[13px] font-normal leading-4.5 tracking-normal ">
            info@totalurgenthealth.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderInfoBar;
